document.addEventListener('DOMContentLoaded', function () {
	const tertiaryNav = document.querySelector('.tertiary-list');
	if (!tertiaryNav) {
		return;
	}
	const currentLink = tertiaryNav.querySelector('.current-post a');
	//create a chevron span to be used as clickable element in second level of flyout
	const chevron = document.createElement('span');
	chevron.classList.add('chevron');
	currentLink && currentLink.after(chevron);
	chevron.addEventListener('click', function (e) {
		e.stopPropagation();
		tertiaryNav.classList.toggle('nav-open');
	});
});
